import { useEffect, useState } from "react";
import { FileText, Download } from "lucide-react";
import { api } from "@/lib/api";

export function AdminQaDocuments() {
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/admin/audit-reports").then((r) => setFiles(r.data?.files || [])).catch(() => setFiles([]));
  }, []);

  const download = async (name) => {
    setBusy(name); setErr("");
    try {
      const r = await api.get(`/admin/audit-reports/${encodeURIComponent(name)}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch (e) {
      setErr(e?.response?.status === 401 ? "Session expired — sign in again." : "Download failed.");
    } finally { setBusy(""); }
  };

  if (!files.length) return null;
  return (
    <div className="ss-card p-5" data-testid="admin-qa-documents">
      <p className="text-[11px] tracking-[0.4em] uppercase text-mauve">QA documents</p>
      <p className="text-xs text-cocoa/55 mt-1">Audit and QA reports of record, stored in <span className="font-mono">docs/audit</span>.</p>
      <ul className="mt-3 space-y-2">
        {files.map((f) => (
          <li key={f} className="flex items-center justify-between gap-3 text-sm text-cocoa">
            <span className="flex items-center gap-2 min-w-0"><FileText size={14} className="text-gold shrink-0" /><span className="truncate">{f}</span></span>
            <button data-testid={`qa-doc-download-${f}`} onClick={() => download(f)} disabled={busy === f}
              className="ss-pill ss-pill-gold h-9 px-3 shrink-0 disabled:opacity-50">
              <Download size={12} /> {busy === f ? "…" : "Download"}
            </button>
          </li>
        ))}
      </ul>
      {err && <p data-testid="qa-doc-error" className="text-rose text-xs mt-2">{err}</p>}
    </div>
  );
}
